{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Alle Optionen sehen",
  "Spoiler_Reveal_Tooltip": "Zum Enthüllen hier klicken",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Twittern",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Element wurde verborgen",
  "Spoiler_Reveal_Video_CTA": "Video enthüllen",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Bild ausdehnen",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Alle Ergebnisse ansehen",
  "Spoiler_Reveal_Image_Placeholder": "Dieses Bild enthält einen Spoiler",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Schieberegler suchen",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Du kannst für mehr als eine Antwort stimmen.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Mehr Audio-Steuerelemente anzeigen",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Schließen",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "{{fileType}} wird geladen",
  "Polls_Plugin_User_Avatar_Alt": "Nutzer-Avatar",
  "Preview_ReadMore_Label": "Weiterlesen",
  "Spoiler_Insert_Tooltip": "Vorschau",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volumen",
  "Spoiler_Reveal_Gallery_Placeholder": "Diese Galerie enthält einen Spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Jetzt buchen",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Stummschaltung aufheben",
  "Spoiler_Reveal_Gallery_CTA": "Galerie enthüllen",
  "Poll_Viewer_ShowLess_CTA": "Weniger anzeigen",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Stummschalten",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} unbekannte",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Folgen",
  "VerticalEmbed_Products_Button": "Jetzt kaufen",
  "Poll_Viewer_Toast_Error_ServerDown": "Die Verbindung zum Server ist nicht möglich. Versuche es später nochmal.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} Person hat für diese Antwort gestimmt",
  "Poll_Viewer_VoteCount": "{{number}} Stimmen",
  "VerticalEmbed_Events_Button": "Jetzt anmelden",
  "Spoiler_Reveal_Image_CTA": "Bild enthüllen",
  "Poll_Viewer_Toast_Error_Connection": "Keine Internetverbindung. Überprüfe deine Verbindung.",
  "Poll_Viewer_Visibility_Owner_Footer": "Nur du kannst die Ergebnisse sehen.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} Personen haben für diese Antwort gestimmt",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Element wurde erweitert",
  "Audio_Plugin_Cover_Alt": "Audio-Cover",
  "Spoiler_Reveal_Video_Placeholder": "Dieses Video enthält einen Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Gesamten Beitrag ansehen",
  "UploadFile_Viewer_Download": "{{fileType}} herunterladen",
  "VerticalEmbed_Units_Hour": "{{hours}} Std.",
  "VerticalEmbed_Units_Minute": "{{minutes}} Min.",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
